export const Type_DocumentDeposit = 1;
